import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { unboxLabel } from '../Configurations';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { ConfigurationSelect } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const HardwareConfig = () => (
  <ConfigurationSelect
    configurationKey="hardware"
    dispatchAction="SET_HARDWARE"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'hardware'> = {
  key: 'hardware',
  input: <HardwareConfig />,
  display: (value: ConfigurationValues['hardware']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
